<script setup>
defineProps({
  type: {
    type: String,
    default: 'default',
    validator: (value) => {
      return ['default', 'birthday', 'christmas'].includes(value)
    },
  },
});
</script>

<template>
  <svg
    width="358"
    height="270"
    viewBox="0 0 358 270"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M125.865 210.093C126.941 211.799 139.413 258.96 140.818 249.803C140.818 242.561 133.97 209.135 133.97 209.135L125.865 210.093Z"
      fill="#692F14"
    />
    <path
      d="M240.079 121.517L214.658 115.382L210.95 126.185L212.744 125.886L210.352 134.354L238.105 132.23L224.737 123.97L240.079 121.517Z"
      fill="#DC8718"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M116.474 207.25C116.863 209.225 111.629 257.733 116.205 249.683C118.806 242.92 124.369 209.255 124.369 209.255L116.474 207.25Z"
      fill="#692F14"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M116.474 207.25C116.863 209.225 111.629 257.733 116.205 249.683C118.806 242.92 124.369 209.255 124.369 209.255L116.474 207.25Z"
      fill="#692F14"
    />
    <path
      d="M52.7421 105.986C65.7217 121.217 110.552 154.104 139.951 138.334C170.456 127.052 158.583 76.899 197.372 80.9986C233.918 85.8165 214.479 139.351 208.498 161.615C196.535 186.453 177.185 207.131 149.401 214.582C56.9889 238.611 34.7381 144.558 52.7421 105.986Z"
      fill="#FFA720"
    />
    <path
      d="M188.52 114.484C189.148 111.642 191.989 109.816 194.83 110.474C195.129 110.534 195.428 110.624 195.727 110.744C201.559 116.31 190.045 121.517 188.52 114.484ZM188.101 107.332C198.06 101.347 206.434 117.178 195.159 121.816C184.572 125.018 179.907 109.158 188.101 107.332Z"
      fill="white"
    />
    <path
      d="M316.701 191.899C316.222 189.415 314.727 187.231 312.544 185.914C311.138 184.867 308.865 184.089 306.473 183.49C306.323 184.508 306.024 185.585 305.575 186.692C305.635 186.692 308.417 186.004 308.776 190.523C308.776 190.523 301.448 195.759 284.85 195.759C259.01 194.892 231.436 200.338 217.589 187.74C217.589 184.957 220.012 185.286 221.776 183.909C223.541 182.533 226.98 184.957 228.386 181.096C228.685 180.259 229.073 179.451 229.492 178.643C224.558 179.271 219.713 180.618 215.167 182.742C208.228 185.735 207.69 189.086 209.813 194.443C209.843 194.533 209.903 194.652 209.963 194.742C210.441 198.213 211.129 203.57 211.967 210.901C213.582 224.816 231.257 224.816 237.118 226.731C240.438 228.048 243.489 229.963 246.091 232.417C246.091 232.417 254.106 234.631 271.781 233.045C275.908 232.686 278.151 234.512 282.966 228.497C287.781 222.482 303.243 224.966 309.224 217.874C312.214 214.307 314.424 210.152 315.712 205.679C316.999 201.205 317.336 196.511 316.701 191.899ZM210.471 194.084C213.911 210.782 300.132 206.413 311.497 199.41C314.159 198.303 315.505 197.106 315.923 195.909C318.136 210.991 204.699 212.427 210.471 194.084ZM210.471 188.218C213.911 204.916 300.132 200.547 311.497 193.545C314.159 192.438 315.505 191.241 315.923 190.044C318.136 205.126 204.669 206.562 210.471 188.218Z"
      fill="#F8F2CF"
    />
    <path
      d="M311.497 199.41C300.132 206.412 213.911 210.781 210.471 194.083C204.699 212.427 318.136 210.991 315.923 195.909C315.505 197.106 314.159 198.303 311.497 199.41Z"
      fill="#C7CCAE"
    />
    <path
      d="M311.497 193.545C300.133 200.547 213.911 204.916 210.472 188.218C204.67 206.562 318.137 205.126 315.923 190.044C315.505 191.241 314.159 192.438 311.497 193.545Z"
      fill="#C7CCAE"
    />
    <path
      d="M221.776 183.909C220.012 185.286 217.589 184.956 217.589 187.739C231.436 200.338 259.01 194.891 284.85 195.759C301.448 195.759 308.776 190.522 308.776 190.522C308.417 186.004 305.635 186.692 305.576 186.692C306.024 185.555 306.323 184.478 306.473 183.49C307.041 179.899 305.546 177.386 300.013 178.313C300.192 176.578 295.736 169.755 292.327 172.029C292.327 171.999 292.327 171.999 292.297 171.969C290.981 172.987 289.665 173.585 289.665 173.585C279.168 172.358 282.487 166.044 287.422 164.279C286.046 164.069 284.102 164.428 281.172 165.416C278.181 160.897 275.459 158.024 270.375 162.962C262.928 158.623 259.938 161.137 259.938 169.605C255.571 164.279 245.253 162.543 247.377 173.795C247.317 173.525 247.227 173.256 247.108 173.017C246.835 172.385 246.441 171.814 245.948 171.335C245.455 170.857 244.872 170.48 244.233 170.227C243.594 169.974 242.911 169.85 242.224 169.861C241.537 169.873 240.859 170.02 240.229 170.293C234.307 172.388 237.059 176.608 234.995 174.842C233.38 173.465 231.107 175.74 229.492 178.642C229.074 179.42 228.685 180.258 228.386 181.096C226.98 184.956 223.541 182.533 221.776 183.909ZM257.994 188.518C254.853 187.47 257.635 182.952 259.728 185.046C259.728 185.046 261.134 189.565 257.994 188.518ZM274.981 191.899C268.73 190.522 263.826 188.547 269.059 186.692V186.662C272.08 185.615 275.34 185.495 278.45 186.303C278.45 186.303 281.231 193.276 274.981 191.899ZM286.226 190.971C283.444 190.612 281.351 194.113 282.398 187.829C282.398 187.829 289.007 191.33 286.226 190.971ZM294.48 176.997C304.02 180.258 286.256 191.54 287.512 182.563C288.559 178.732 294.48 176.997 294.48 176.997ZM282.398 169.007C282.398 169.007 285.538 176.338 282.398 175.979C279.257 175.62 278.899 168.648 282.398 169.007ZM273.216 173.076V173.047C273.725 170.772 275.1 168.827 277.074 167.6C282.069 177.236 271.751 181.006 273.216 173.076ZM260.685 174.124C270.943 180.498 259.758 183.221 257.904 179.031C257.904 177.266 260.685 174.124 260.685 174.124ZM254.853 170.742C254.853 170.742 257.635 177.356 253.448 175.62C249.261 173.884 251.354 168.648 254.853 170.742ZM254.734 181.755C254.913 183.61 254.405 185.256 253.627 186.692C253.926 187.47 253.777 188.218 253.029 188.757C252.7 188.936 252.311 189.056 251.893 189.206C250.607 190.672 249.351 191.54 249.351 191.54C246.27 190.971 244.386 189.774 243.369 188.248C242.801 187.739 242.472 187.081 242.562 186.303V186.243C241.306 179.63 251.534 170.892 254.734 181.755ZM240.199 172.149C240.199 172.149 245.104 177.356 241.964 177.715C238.823 178.074 236.042 172.478 240.199 172.149Z"
      fill="#FFB824"
    />
    <path
      d="M282.398 175.979C285.538 176.338 282.398 169.007 282.398 169.007C278.899 168.648 279.258 175.62 282.398 175.979ZM241.964 177.715C245.104 177.356 240.199 172.149 240.199 172.149C236.042 172.478 238.823 178.074 241.964 177.715ZM253.448 175.62C257.635 177.356 254.853 170.742 254.853 170.742C251.354 168.648 249.261 173.885 253.448 175.62ZM282.398 187.829C281.351 194.114 283.445 190.612 286.226 190.971C289.007 191.331 282.398 187.829 282.398 187.829ZM257.994 188.518C261.134 189.565 259.728 185.046 259.728 185.046C257.635 182.952 254.854 187.47 257.994 188.518Z"
      fill="#DC7D16"
    />
    <path
      d="M277.074 167.6C275.1 168.827 273.725 170.772 273.216 173.047V173.077C271.751 181.007 282.069 177.236 277.074 167.6ZM257.904 179.032C259.758 183.221 270.943 180.498 260.685 174.124C260.685 174.124 257.904 177.266 257.904 179.032ZM287.512 182.563C286.256 191.54 304.02 180.258 294.48 176.997C294.48 176.997 288.558 178.732 287.512 182.563ZM253.029 188.757C253.807 188.218 253.926 187.47 253.627 186.692C253.119 187.65 252.521 188.488 251.893 189.206C252.311 189.056 252.7 188.937 253.029 188.757ZM269.059 186.662V186.692C263.825 188.548 268.73 190.523 274.981 191.899C281.231 193.276 278.45 186.303 278.45 186.303C275.353 185.492 272.085 185.617 269.059 186.662ZM242.562 186.303C242.472 187.111 242.801 187.74 243.369 188.248C242.95 187.62 242.681 186.932 242.562 186.243V186.303Z"
      fill="#FED749"
    />
    <path
      d="M242.561 186.243C242.711 186.962 242.95 187.62 243.369 188.248C244.386 189.744 246.27 190.971 249.35 191.54C249.35 191.54 250.606 190.672 251.892 189.206C252.52 188.488 253.119 187.65 253.627 186.692C254.375 185.256 254.913 183.61 254.733 181.755C251.533 170.892 241.305 179.63 242.561 186.243ZM289.665 173.585C289.665 173.585 290.981 172.987 292.297 171.969C293.822 170.832 295.347 169.156 295.018 167.151C293.403 163.68 290.173 163.261 287.422 164.279C282.487 166.044 279.167 172.358 289.665 173.585Z"
      fill="#FF630F"
    />
    <path
      d="M189.686 112.06C185.409 116.04 193.993 120.409 196.445 116.28C199.525 111.163 193.305 108.23 189.686 112.06Z"
      fill="#060505"
    />
    <path
      d="M243.04 144.409L238.734 144.14C250.637 100.45 283.923 147.431 243.04 144.409ZM238.734 144.14L238.225 145.337C238.225 145.337 231.556 143.84 238.734 144.14ZM175.122 175.71L246.001 136.808L248.992 142.284L177.783 180.229C171.264 179.959 175.122 175.71 175.122 175.71Z"
      fill="#B06E28"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M256.857 136.898C256.857 136.898 258.442 128.968 253.687 125.586C239.152 119.302 241.605 149.227 256.857 136.898Z"
      fill="#FF630F"
    />
    <path
      d="M191.331 171.7C188.55 165.206 180.594 166.343 174.793 161.915C162.022 152.099 157.267 142.883 151.645 139.052C108.339 112.12 81.3931 185.076 142.942 184.747C157.327 184.747 182.568 183.969 193.783 174.722L191.331 171.7Z"
      fill="#FFC72B"
    />
    <path
      v-if="type === 'default'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M209.814 84.5898L213.851 68.1612C253.538 70.1063 254.824 31.5635 216.214 40.2715C216.573 19.3243 174.344 10.7958 178.082 38.8052C151.316 12.5015 119.405 54.1565 169.11 63.7623L174.763 87.5224L209.814 84.5898Z"
      fill="#F8F2CF"
    />
    <path
      v-if="type === 'birthday'"
      d="M168 34V95.5234L212.954 84.9996L168 34Z"
      fill="#FCE3EA"
    />
    <path
      v-if="type === 'birthday'"
      d="M170.932 44.5239C172.551 44.5239 173.864 43.4366 173.864 42.0953C173.864 40.754 172.551 39.6667 170.932 39.6667C169.313 39.6667 168 40.754 168 42.0953C168 43.4366 169.313 44.5239 170.932 44.5239Z"
      fill="#D82B91"
    />
    <path
      v-if="type === 'birthday'"
      d="M181.681 61.5236C183.3 61.5236 184.613 60.4363 184.613 59.0951C184.613 57.7538 183.3 56.6665 181.681 56.6665C180.062 56.6665 178.75 57.7538 178.75 59.0951C178.75 60.4363 180.062 61.5236 181.681 61.5236Z"
      fill="#D82B91"
    />
    <path
      v-if="type === 'birthday'"
      d="M191.454 69.6188C193.073 69.6188 194.386 68.5315 194.386 67.1903C194.386 65.849 193.073 64.7617 191.454 64.7617C189.835 64.7617 188.522 65.849 188.522 67.1903C188.522 68.5315 189.835 69.6188 191.454 69.6188Z"
      fill="#D82B91"
    />
    <path
      v-if="type === 'birthday'"
      d="M183.636 77.714C185.255 77.714 186.568 76.6267 186.568 75.2855C186.568 73.9442 185.255 72.8569 183.636 72.8569C182.017 72.8569 180.704 73.9442 180.704 75.2855C180.704 76.6267 182.017 77.714 183.636 77.714Z"
      fill="#D82B91"
    />
    <path
      v-if="type === 'birthday'"
      d="M177.773 85.8093C179.392 85.8093 180.704 84.722 180.704 83.3807C180.704 82.0394 179.392 80.9521 177.773 80.9521C176.153 80.9521 174.841 82.0394 174.841 83.3807C174.841 84.722 176.153 85.8093 177.773 85.8093Z"
      fill="#D82B91"
    />
    <path
      v-if="type === 'birthday'"
      d="M202.204 85.8093C203.823 85.8093 205.136 84.722 205.136 83.3807C205.136 82.0394 203.823 80.9521 202.204 80.9521C200.585 80.9521 199.272 82.0394 199.272 83.3807C199.272 84.722 200.585 85.8093 202.204 85.8093Z"
      fill="#D82B91"
    />
    <path
      v-if="type === 'birthday'"
      d="M172.886 52.6188C174.506 52.6188 175.818 51.5315 175.818 50.1903C175.818 48.849 174.506 47.7617 172.886 47.7617C171.267 47.7617 169.955 48.849 169.955 50.1903C169.955 51.5315 171.267 52.6188 172.886 52.6188Z"
      fill="#34B98B"
    />
    <path
      v-if="type === 'birthday'"
      d="M177.773 69.6188C179.392 69.6188 180.704 68.5315 180.704 67.1903C180.704 65.849 179.392 64.7617 177.773 64.7617C176.153 64.7617 174.841 65.849 174.841 67.1903C174.841 68.5315 176.153 69.6188 177.773 69.6188Z"
      fill="#34B98B"
    />
    <path
      v-if="type === 'birthday'"
      d="M191.454 84.9994C193.073 84.9994 194.386 83.9121 194.386 82.5709C194.386 81.2296 193.073 80.1423 191.454 80.1423C189.835 80.1423 188.522 81.2296 188.522 82.5709C188.522 83.9121 189.835 84.9994 191.454 84.9994Z"
      fill="#34B98B"
    />
    <path
      v-if="type === 'birthday'"
      d="M171.909 93.0949C173.528 93.0949 174.841 92.0076 174.841 90.6663C174.841 89.3251 173.528 88.2378 171.909 88.2378C170.29 88.2378 168.977 89.3251 168.977 90.6663C168.977 92.0076 170.29 93.0949 171.909 93.0949Z"
      fill="#34B98B"
    />
    <path
      v-if="type === 'birthday'"
      d="M172.886 77.714C174.506 77.714 175.818 76.6267 175.818 75.2855C175.818 73.9442 174.506 72.8569 172.886 72.8569C171.267 72.8569 169.955 73.9442 169.955 75.2855C169.955 76.6267 171.267 77.714 172.886 77.714Z"
      fill="#ED174F"
    />
    <path
      v-if="type === 'birthday'"
      d="M198.295 77.714C199.914 77.714 201.227 76.6267 201.227 75.2855C201.227 73.9442 199.914 72.8569 198.295 72.8569C196.676 72.8569 195.363 73.9442 195.363 75.2855C195.363 76.6267 196.676 77.714 198.295 77.714Z"
      fill="#ED174F"
    />
    <path
      v-if="type === 'birthday'"
      d="M179.727 55.8571C181.346 55.8571 182.659 54.7698 182.659 53.4286C182.659 52.0873 181.346 51 179.727 51C178.108 51 176.795 52.0873 176.795 53.4286C176.795 54.7698 178.108 55.8571 179.727 55.8571Z"
      fill="#ED174F"
    />
    <path
      v-if="type === 'birthday'"
      d="M171.909 62.3332C173.528 62.3332 174.841 61.2459 174.841 59.9046C174.841 58.5634 173.528 57.4761 171.909 57.4761C170.29 57.4761 168.977 58.5634 168.977 59.9046C168.977 61.2459 170.29 62.3332 171.909 62.3332Z"
      fill="#ED174F"
    />
    <path
      v-if="type === 'birthday'"
      d="M296.877 147.634C296.877 147.634 266.42 131.044 270.35 90.0581C274.28 49.0718 302.772 44.1925 319.474 48.096C336.176 51.9994 355.826 71.5167 349.931 103.72C344.036 135.924 317.509 150.562 296.877 147.634Z"
      fill="#5E7EBF"
    />
    <path
      v-if="type === 'birthday'"
      d="M290 156L299 159V151L293.273 149L290 156Z"
      fill="#5E7CBD"
    />
    <path
      v-if="type === 'christmas'"
      d="M216.903 90.0746C216.903 90.0746 211.739 73.7581 196.304 68.1575C180.869 62.5569 156.292 62.7081 155.703 69.8838C155.114 77.0596 161.209 73.2251 162.832 79.8599C164.455 86.4947 162.49 92.8351 163.572 97.2584C164.654 101.682 164.074 94.1546 191.736 91.4354C207.979 89.8387 216.314 97.2504 217.985 94.4978C219.655 91.7453 216.903 90.0746 216.903 90.0746Z"
      fill="#125D78"
    />
    <path
      v-if="type === 'christmas'"
      d="M190.091 84.7096C190.091 84.7096 209.972 83.4113 217.496 89.8869C225.021 96.3626 218.295 98.0077 216.9 97.161C215.504 96.3142 201.253 91.4837 195.373 91.7337C189.494 91.9837 170.71 97.7658 167.621 99.7093C164.532 101.653 163.984 99.4109 163.435 97.169C162.887 94.9272 167.669 90.1934 172.154 89.0966C176.638 87.9999 184.211 84.9596 190.091 84.7096Z"
      fill="#545AA8"
    />
    <path
      v-if="type === 'christmas'"
      d="M164.187 69.7795C164.187 69.7795 165.582 70.6262 163.888 73.4165C162.194 76.2068 162.194 76.2067 159.952 76.7551C157.71 77.3035 153.774 80.6421 151.831 77.5535C149.887 74.4649 145.701 71.9246 147.395 69.1343C149.088 66.3441 147.992 61.8603 150.234 61.3119C152.476 60.7635 153.871 61.6103 156.113 61.0619C158.355 60.5135 159.202 59.1184 161.993 60.8119C164.783 62.5054 163.09 65.2957 163.638 67.5376L164.187 69.7795Z"
      fill="#5359A7"
    />
  </svg>
</template>
